import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter } from '../../../global/commonStyle';

const ModalBlock = styled.form`
  display: flex;
  flex-direction: column;
  width: 520px;
  ${mobile_xl(css`
    width: unset;
  `)}
`;

const Formation = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  padding: var(--space-16) var(--space-16) var(--space-24);
  ${mobile_xl(css`
    gap: var(--space-20);
  `)}
`;

const FormBlock = styled.div`
  display: flex;
  gap: var(--space-12);
  align-items: flex-end;
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-20);
  `)}
`;

const Form = styled.div`
  max-width: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  ${mobile_xl(css`
    max-width: 100%;
  `)}
`;

const Label = styled.label<{ isDisabled?: boolean }>`
  ${Typography.body_md_medium}
  color: ${({ isDisabled }) => (isDisabled ? 'var(--text-muted)' : 'var(--text-secondary)')};
`;

const FormButton = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: var(--space-12);
  padding: var(--space-0) var(--space-16) var(--space-16);
`;
const BillingTitle = styled.div`
  color: var(--text-primary);
  ${Typography.body_md}
`;
const Check = styled.div`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-10);
  ${mobile_xl(css`
    padding-block: var(--space-0);
  `)}
`;

const SelectedText = styled.div`
  position: absolute;
  color: var(--text-primary);
  top: 8px;
  left: 12px;
  pointer-events: none;
  overflow: hidden;
  max-width: calc(100% - 40px);
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${Typography.body_lg}
`;

export { ModalBlock, Formation, FormBlock, Form, Label, FormButton, Check, BillingTitle, SelectedText };
